module.exports = __webpack_public_path__ + "img/icon-download.0fe4d249.svg";